import { Navigate } from "react-router-dom";
import {
  PageContainer,
  PageHeader,
  PageMainCard,
} from "@volca/ui/components/ui/page-components";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { Stack } from "@volca/ui/components/ui/stack";
import { useBusiness } from "@/core/business";
import { FEATURE_FLAG_NAMES } from "@/core/feature-flags/feature-flag-name";
import { useFeatureFlag } from "@/core/feature-flags/use-feature-flag";
import { useGetPocketflowsEmbedUrl } from "./query";

export const Campaigns = () => {
  const {
    businessId,
    isLoading: isBusinessLoading,
    selectedBusiness: { is_pocketflows_enabled } = {},
  } = useBusiness();

  const {
    enabled: enablePocketflowsFlag,
    isLoading: isEnablePocketflowsLoading,
  } = useFeatureFlag(FEATURE_FLAG_NAMES.enable_pocketflows);

  const { data, isLoading } = useGetPocketflowsEmbedUrl(businessId);
  const embedUrl = data?.url;

  const isPageLoading =
    isLoading || isBusinessLoading || isEnablePocketflowsLoading;

  if (
    !isPageLoading &&
    (!is_pocketflows_enabled || !enablePocketflowsFlag || !embedUrl)
  ) {
    return <Navigate to="/" replace />;
  }

  return (
    <PageContainer variant="workspace">
      <PageHeader title="Campaigns" />
      <PageMainCard>
        {isPageLoading ? (
          <Stack
            gap={4}
            align="center"
            justify="center"
            className="h-full w-full"
          >
            <Spinner layout="centered" />
          </Stack>
        ) : (
          <iframe src={embedUrl} title="Campaigns" className="h-full w-full" />
        )}
      </PageMainCard>
    </PageContainer>
  );
};
